import React from 'react'

export const Goblet = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_3190)'>
      <path
        d='M11 19V13.889L3 5V3H21V5L13 13.889V19H18V21H6V19H11ZM7.49 7H16.51L18.31 5H5.69L7.49 7Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_3190'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
